import "../css/main.css";
import Navbar from "../components/Navbar";

function Gallery() {
    return (
        <div>
            {/* Nav Bar */}
            <Navbar></Navbar>
        </div>
    );
}

export default Gallery;